import React, { useState, useEffect } from "react";
// import certificates from "../../constants/certificates";
import "./Achievement.css";
import { client, urlFor } from "../../client";

const Achievement = () => {
  const [certificates, setCertificates] = useState([]);
  const [currentCertificateIndex, setCurrentCertificateIndex] = useState(0);

  useEffect(() => {
    const query = '*[_type == "certificates"]';

    client.fetch(query).then((data) => {
      setCertificates(data);
    });
  }, []);

  useEffect(() => {
    if (certificates.length > 0) {
      const interval = setInterval(() => {
        showNextCertificate();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [certificates]);

  const updateCertificateDisplay = (index) => {
    setCurrentCertificateIndex(index);
  };

  const showNextCertificate = () => {
    setCurrentCertificateIndex(
      (prevIndex) => (prevIndex + 1) % certificates.length
    );
  };

  const showPreviousCertificate = () => {
    setCurrentCertificateIndex(
      (prevIndex) => (prevIndex - 1 + certificates.length) % certificates.length
    );
  };

  return (
    <section className="skills" id="achievement">
      <div className="skills-content section-content">
        <p className="section-subtitle">Certificates &amp; Achievements</p>

        <h2 className="h3 section-title">
          Recognitions and milestones showcasing my dedication and expertise.
        </h2>

        <p className="section-text">
          A testament to my accomplishments and expertise, highlighting notable
          recognitions and achievements.
        </p>
      </div>

      <div className="skills-box">
        <div id="certificates" className="section certificates-section">
          {certificates.length > 0 ? (
            <div className="container">
              <div className="certificate-container">
                <img
                  src={urlFor(certificates[currentCertificateIndex]?.imgUrl)}
                  alt={certificates[currentCertificateIndex]?.title}
                  id="certificateImage"
                  loading="lazy"
                />
                <h3>{certificates[currentCertificateIndex]?.title}</h3>
                <p>{certificates[currentCertificateIndex]?.description}</p>
                <div className="certificate-controls">
                  {/* Previous SVG icon */}
                  <svg
                    className="svg-icon"
                    onClick={showPreviousCertificate}
                    height="48px"
                    width="48px"
                    version="1.1"
                    id="Capa_1"
                    viewBox="0 0 55.753 55.753"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path d="M12.745,23.915c0.283-0.282,0.59-0.52,0.913-0.727L35.266,1.581c2.108-2.107,5.528-2.108,7.637,0.001 c2.109,2.108,2.109,5.527,0,7.637L24.294,27.828l18.705,18.706c2.109,2.108,2.109,5.526,0,7.637 c-1.055,1.056-2.438,1.582-3.818,1.582s-2.764-0.526-3.818-1.582L13.658,32.464c-0.323-0.207-0.632-0.445-0.913-0.727 c-1.078-1.078-1.598-2.498-1.572-3.911C11.147,26.413,11.667,24.994,12.745,23.915z"></path>
                    </g>
                  </svg>
                  {/* Next SVG icon */}
                  <svg
                    className="svg-icon"
                    onClick={showNextCertificate}
                    height="48px"
                    width="48px"
                    version="1.1"
                    id="Capa_1"
                    viewBox="0 0 55.753 55.753"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path d="M43.006,23.916c-0.28-0.282-0.59-0.52-0.912-0.727L20.485,1.581c-2.109-2.107-5.527-2.108-7.637,0.001 c-2.109,2.108-2.109,5.527,0,7.637l18.611,18.609L12.754,46.535c-2.11,2.107-2.11,5.527,0,7.637c1.055,1.053,2.436,1.58,3.817,1.58 s2.765-0.527,3.817-1.582l21.706-21.703c0.322-0.207,0.631-0.444,0.912-0.727c1.08-1.08,1.598-2.498,1.574-3.912 C44.605,26.413,44.086,24.993,43.006,23.916z"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div id="dot" className="dots">
                {certificates.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${
                      index === currentCertificateIndex ? "active" : ""
                    }`}
                    onClick={() => updateCertificateDisplay(index)}
                  ></span>
                ))}
              </div>
            </div>
          ) : (
            <div className="mini-loader2 load-more"></div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Achievement;
